import { ROUTES } from '@/common/constants/routes';
import { HomeLayout } from '@/common/containers/Dashboard/Home/HomeLayout/HomeLayout';
import { PocketCardsGrid } from '@/common/containers/Dashboard/Home/PocketCardsGrid/PocketCardsGrid';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import { useGetESHomeSecondaryActions } from './ESHomePage.utils';
import { ESMealCardPocket } from './ESMealCardPocket/ESMealCardPocket';

export function ESMealHomePage() {
  const {
    features: { ff_sea_activity },
  } = useFeatures();
  const secondaryActions = useGetESHomeSecondaryActions();

  return (
    <HomeLayout
      pocketCardsSlot={
        <PocketCardsGrid>
          <ESMealCardPocket />
        </PocketCardsGrid>
      }
      secondaryActionsSlot={secondaryActions}
      activityRoute={ff_sea_activity ? ROUTES.HOME_ACTIVITY : undefined}
    />
  );
}
